export const getWeekStart = (date = new Date()) => {
  const baseDate = new Date(date);
  const day = baseDate.getDay();
  const diff = day === 0 ? -6 : 1 - day; // Adjust so Monday is start of week
  baseDate.setDate(baseDate.getDate() + diff);
  baseDate.setHours(0, 0, 0, 0);
  return baseDate;
};

export const toDate = (value) => {
  if (!value) return new Date();
  return value instanceof Date ? new Date(value.getTime()) : new Date(value);
};

export const isSameDay = (first, second) => {
  if (!first || !second) return false;
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate()
  );
};
